import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './CounterpartiesTableHead.scss';

export const COUNTERPARTIES_TABLE_HEADER = [
  {
    label: 'counterpartyNumber'
  },
  {
    label: 'internalCounterparty'
  },
  {
    label: 'partyName'
  },
  {
    label: 'accountNumberSortCodeBic'
  },
  {
    label: 'action'
  }
];

const CounterpartiesTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {COUNTERPARTIES_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'counterparties-table-head'}>
              <div className={'counterparties-table-head-block'}>
                <span>{i18n.getMessage(`counterparties.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`counterparties-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

CounterpartiesTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default CounterpartiesTableHead;
